import { ModalControlsSaveableFactory } from '®shared/modals';

import {
  ArchiveListActionTypes,
  ArchiveListActions,
} from './archive-list.actions';
import {
  ARCHIVE_LIST_INITIAL_STATE,
  ArchiveListState,
} from './archive-list.state';

export function archiveListReducer(
  state: ArchiveListState = ARCHIVE_LIST_INITIAL_STATE,
  action: ArchiveListActions,
): ArchiveListState {
  switch (action.type) {
    case ArchiveListActionTypes.ARCHIVE_LIST_SHOW_MODAL: {
      return {
        modalControl: ModalControlsSaveableFactory.show(),
      };
    }

    case ArchiveListActionTypes.ARCHIVE_LIST: {
      return {
        modalControl: ModalControlsSaveableFactory.saving(),
      };
    }

    case ArchiveListActionTypes.ARCHIVE_LIST_FAILED: {
      return {
        modalControl: ModalControlsSaveableFactory.errorSaving(
          action.payload.error,
        ),
      };
    }

    case ArchiveListActionTypes.ARCHIVE_LIST_HIDE_MODAL: {
      return {
        ...ARCHIVE_LIST_INITIAL_STATE,
        modalHiddenReason: action.payload.reason,
      };
    }

    default: {
      return state;
    }
  }
}
